import { createSvgIcon } from '@mui/material/utils';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var Sidebar2Icon = createSvgIcon( /*#__PURE__*/_jsxs(_Fragment, {
  children: [/*#__PURE__*/_jsx("path", {
    d: "M13,4H3A1,1,0,0,0,2,5V19a1,1,0,0,0,1,1H13a1,1,0,0,0,1-1V5A1,1,0,0,0,13,4Zm-1,13.5a.5.5,0,0,1-.5.5h-7a.5.5,0,0,1-.5-.5v-11A.5.5,0,0,1,4.5,6h7a.5.5,0,0,1,.5.5Z"
  }), /*#__PURE__*/_jsx("rect", {
    x: "16",
    y: "3.97",
    width: "6",
    height: "16",
    rx: "1"
  })]
}), 'SideBar2Icon');